import { useMemo, forwardRef } from "react";
import { Link, useLocation } from "react-router-dom";
import classnames from "classnames";

import {
  PublishedNavigationElement,
  PublishedNavigationElementChildrenInner,
} from "@/lib/api";

import styles from "./navigation.module.css";

interface NavigationSubItemsProps {
  subitems: PublishedNavigationElement["children"];
}

const NavigationSubItems = forwardRef<HTMLDivElement, NavigationSubItemsProps>(
  ({ subitems }, ref) => {
    if (!subitems || subitems.length === 0) return null;

    return (
      <div ref={ref} className={styles.navigationSubitems}>
        {subitems.map((item) => (
          <NavigationSubitemsItem key={item.id} item={item} />
        ))}
      </div>
    );
  },
);

NavigationSubItems.displayName = "NavigationSubItems";

export default NavigationSubItems;

interface NavigationSubitemsItemProps {
  item: PublishedNavigationElementChildrenInner;
}

function NavigationSubitemsItem({ item }: NavigationSubitemsItemProps) {
  const location = useLocation();

  const isActive = useMemo(() => {
    return location.pathname === item.full_path;
  }, [item, location]);

  return (
    <Link
      key={item.id}
      to={item.full_path ?? ""}
      className={classnames(styles.navigationSubitemsItem, {
        [styles.NavigationSubitemsItemActive]: isActive,
      })}
    >
      {item.title}
    </Link>
  );
}
